import { Stack, Text } from '@fluentui/react';
import { useTheme } from '@h2oai/ui-kit';

interface StatCardProps {
  title: string;
  value: string | number;
  isLoading?: boolean;
}

export function StatCard({ title, value, isLoading }: StatCardProps) {
  const theme = useTheme();
  return (
    <div
      style={{
        background: theme.palette?.white,
        padding: '16px 20px',
        borderRadius: 4,
        border: `1px solid ${theme.palette?.gray200}`,
        flex: 1,
      }}
    >
      <Stack tokens={{ childrenGap: 8 }}>
        <Text
          variant="small"
          styles={{
            root: {
              color: theme.palette?.gray600,
              fontWeight: 400,
            },
          }}
        >
          {title}
        </Text>
        <Text
          variant="xxLarge"
          styles={{
            root: {
              color: theme.palette?.black,
              fontWeight: 600,
              fontSize: 28,
            },
          }}
        >
          {isLoading ? '...' : value}
        </Text>
      </Stack>
    </div>
  );
}
